import React from 'react';
import { draftToHtml} from 'react-wysiwyg-typescript';
import ReactHtmlParser from 'react-html-parser';

import './FooterComponentStyle.css';

export default class FooterComponent extends React.Component {
    
    getHTML = () =>{
        const footer = this.props.data.footerText;
        if (!footer || !footer.content) return "";
        try {
            const parsed = JSON.parse(footer.content);
            
            let text = parsed.blocks.map(b => b.text).join("") || "";
            if (footer.isHtml) {
                const textarea = document.createElement("textarea");
                textarea.innerHTML = text;
                text = textarea.value;
                return ReactHtmlParser(text);
            }
            
            return ReactHtmlParser(draftToHtml(parsed));
        }catch(e){
            console.warn('error:::', e);
            return "";
        }
    }
    
    render() {
        return (
            <div className="footerContainer">
            {
                this.getHTML()
            }
            </div>
        );
    }
    
}


// WEBPACK FOOTER //
// ./src/client/components/Footer-Component/FooterComponent.js